'use client';

import {usePathname} from 'next/navigation';
import {useLayoutEffect, useRef} from 'react';

// Next.js App Router scrollt bei geteiltem Layout zum Top des geänderten Segments,
// nicht zum Page-Top. Im Catch-all `[...categories]` rendert page.tsx nur die
// Produktgrid; H1/Breadcrumb/Intro liegen im Layout. Resultat: Klick auf eine
// Kategorie landet mitten in der Filter-Bar statt oben. Dieser Override scrollt
// bei jedem echten Pathname-Wechsel auf (0,0). Filter ändern den Pathname
// ebenfalls und scrollen ohnehin schon selbst zu 0.
//
// Der Reset wird über mehrere Animation Frames wiederholt, weil
// @tanstack/react-virtual (useWindowVirtualizer in VariantGrid) nach dem ersten
// Reset eigene scrollAdjustments anstößt und das Fenster zurück auf die alte
// Position zieht. Sechs Frames (~100ms bei 60fps) reichen, um die letzte
// virtualizer-Adjustment-Welle zu übertönen.
export default function ScrollResetOnNav() {
    const pathname = usePathname();
    const previous = useRef(pathname);

    useLayoutEffect(() => {
        if (previous.current === pathname) return;
        previous.current = pathname;

        // Loop läuft bewusst ohne cleanup-cancel — React StrictMode würde sonst
        // im dev-Mode den Reset gleich wieder abbrechen, und nach 6 frames ist
        // er ohnehin durch.
        // setTimeout-Kaskade statt rAF: rAF wurde in den hier beobachteten
        // App-Router-Render-Zyklen verworfen, setTimeout-Slots überleben.
        // useWindowVirtualizer scrollt nach unserem Reset im nächsten Frame
        // erneut zurück; Frame 2 in dieser Schleife übertönt das endgültig.
        let frame = 0;
        const reset = () => {
            window.scrollTo(0, 0);
            if (frame++ < 8) setTimeout(reset, 16);
        };
        reset();
    }, [pathname]);

    return null;
}
